import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'

import { ServicesValuesTypes } from '../components/Filters/Services/Services.types'
import PARK_AND_FLY_SERVICES from '../components/Filters/Services/ServicesSubFilters'

export const useServiceFilter = () => {
  const [selectedServices, setSelectedServices] = useState<
    ServicesValuesTypes[]
  >([])
  const router = useRouter()

  const updateServicesBasedOnParkAndFly = (services: ServicesValuesTypes[]) => {
    if (!services.includes(ServicesValuesTypes.PARK_AND_FLY)) {
      return services.filter(
        service => !PARK_AND_FLY_SERVICES.includes(service)
      )
    }
    return services
  }

  const handleAddRemoveService = (service: ServicesValuesTypes) => {
    let updatedServices = selectedServices.includes(service)
      ? selectedServices.filter(s => s !== service)
      : [...selectedServices, service]

    updatedServices = updateServicesBasedOnParkAndFly(updatedServices)

    setSelectedServices(updatedServices)

    const newQuery: any = { ...router.query, service: updatedServices }
    router.push(
      {
        pathname: router.pathname,
        query: newQuery
      },
      undefined,
      { shallow: true }
    )
  }

  const syncServicesWithQuery = () => {
    if (router.query.service) {
      const services = Array.isArray(router.query.service)
        ? router.query.service
        : [router.query.service]
      setSelectedServices(services as ServicesValuesTypes[])
    }
  }

  useEffect(() => {
    syncServicesWithQuery()
  }, [router.query])

  return { selectedServices, setSelectedServices, handleAddRemoveService }
}
